import request from '@/utils/request'

/**
 * 查询标签信息列表
 * @param {string} tagName
 * @param {string} pageNum
 * @param {string} pageSize
 * @returns
 */
export function getTags(tagName, pageNum = 1, pageSize = 10) {
  return request({
    method: "GET",
    url: "/device/tag/list",
    params: {
      tagName,
      pageNum,
      pageSize,
    },
  })
}

/**
 * 新增标签
 * @param {*} tagName
 * @param {*} remark
 * @param {*} createBy
 * @param {*} stationIds
 * @returns
 */
export function createTag(tagName, remark, createBy, stationIds) {
  return request({
    method: "POST",
    url: "/device/tag",
    data: {
      tagName,
      remark,
      createBy,
      stationIds
    },
  })
}

/**
 * 修改标签
 * @param {*} id
 * @param {*} tagName
 * @param {*} remark
 * @param {*} updateBy
 * @param {*} stationIds
 * @returns
 */
export function modifyTag(id, tagName, remark, updateBy, stationIds) {
  return request({
    method: "PUT",
    url: "/device/tag",
    data: {
      id,
      tagName,
      remark,
      updateBy,
      stationIds
    },
  })
}

/**
 * 删除标签
 * @param {*} tagIds
 * @returns
 */
export function delTag(tagIds) {
  return request({
    method: "DELETE",
    url: `/device/tag/${tagIds}`,
  })
}



/**
 * 固件列表
 * @param {*} fileName
 * @param {*} stationTag
 * @param {*} pageNum
 * @param {*} pageSize
 * @returns
 */
export function getFileList(fileName, stationTag, pageNum = 1, pageSize = 10, fileType) {
  return request({
    method: "GET",
    url: `/device/upgrade/file/list`,
    params: {
      fileName,
      stationTag,
      pageNum,
      pageSize,
      fileType,
    }
  })
}


/**
 * 固件文件上传
 * @param {*} file 
 * @returns 
 */
export function uploadFile(file) {
  const fd = new FormData()
  fd.append('deviceFile', file)

  return request({
    method: "POST",
    url: `/device/upgrade/file/upload`,
    data: fd,
  })
}


/**
 * 添加固件文件
 * @param {*} fileName 
 * @param {*} fileUrl
 * @param {*} fileMd5
 * @param {*} fileType
 * @param {*} fileSize
 * @param {*} stationTag
 * @returns 
 */
export function addPackage({ fileName, fileUrl, fileMd5, fileType, fileSize, stationTag }) {
  return request({
    method: "POST",
    url: `/device/upgrade/file`,
    data: {
      fileName,
      fileUrl,
      fileMd5,
      fileType,
      fileSize,
      stationTag
    },
  })
}


/**
 * 查询所有标签信息(下拉框)
 * @returns 
 */
export function getTagSelectOptions() {
  return request({
    method: "GET",
    url: `/device/tag/all/list`,
  })
}


/**
 * 删除固件文件
 * @returns 
 */
export function removePackage(id) {
  return request({
    method: "DELETE",
    url: `/device/upgrade/file/${id}`,
  })
}




/**
 * 查询电站下的升级文件列表
 * @param {string} stationId 电站ID
 * @returns 
 */
export function packagesFromStationId(stationId) {
  return request({
    method: "GET",
    url: `/device/upgrade/file/list/${stationId}`,
  })
}



/**
 * 设备升级命令下发
 * @param {*} stationId 电站ID 必填
 * @param {*} uuids eLink的uuid 必填
 * @param {*} fileObj  文件信息 必填
 * @returns 
 */
export function postUpgradeCommand(stationId, uuids, fileObj, secretFileObj) {

  const file = {
    id: fileObj.id
  }

  // 取file开头的属性

  const takingAttributesStartingWithFile = (fileObj) => {
    let out = {}
    Object.keys(fileObj).forEach(key => {
      if (key.includes('file')) {
        out[key] = fileObj[key]
      }
    })

    return out
  }

  Object.assign(file, takingAttributesStartingWithFile(fileObj))

  const postData = {
    stationId,
    uuids,
    file
  }

  if (secretFileObj) {
    postData.secretFile = takingAttributesStartingWithFile(secretFileObj)
  }

  return request({
    method: "POST",
    url: `/command/file/upgrade/down`,
    data: postData,
  })
}


/**
 * 查询设备升级列表
 * @param {*} stationId 
 * @param {*} upgradeState 升级状态 `upgrading upgrade_success upgrade_fail`
 * @param {*} pageNum 
 * @param {*} pagaSize 
 * @returns 
 */
export function getUpgradeList(stationId, upgradeState = 'upgrading', pageNum = 1, pagaSize = 10) {
  return request({
    method: "GET",
    url: `/command/file/upgrade/list`,
    params: {
      stationId,
      upgradeState,
      pageNum,
      pagaSize
    }
  })
}


/**
 * 查询电站下的设备版本信息
 * @param {*} stationId 
 * @returns 
 */
export function getVersions(stationId) {
  return request({
    method: "GET",
    url: '/command/device/version/list',
    params: {
      stationId,
    }
  })
}


/**
 * 结束升级
 * @param {*} id 
 * @param {*} resultMsg 
 * @returns 
 */
export function shutdownUpgrade(id, resultMsg) {
  return request({
    method: "put",
    url: '/command/file/upgrade',
    data: {
      id,
      resultMsg
    }
  })
}


/**
 * 查询电站下的设备版本信息V2
 * @param {*} stationId 电站ID
 * @returns 
 */
export function versionList(stationId) {
  return request({
    method: "get",
    url: '/command/v2/device/version/list',
    params: {
      stationId,
    }
  })
}




/**
 * 查询电站下特定eLink的设备版本历史信息V2
 * @param {*} stationId 电站ID
 * @param {*} uuid elink uuid
 * @param {*} startTime 
 * @param {*} endTime 
 * @param {*} pageSize 
 * @param {*} pageNum 
 * @returns 
 */
export function versionHistoryList(stationId, uuid, startTime, endTime, pageSize, pageNum) {
  return request({
    method: "get",
    url: '/command/v2/device/version/history/list',
    params: {
      stationId,
      uuid,
      startTime,
      endTime,
      pageSize,
      pageNum,
    }
  })
}


/**
 * 查询设备版本详情信息V2
 * @param {string} id elink版本信息的主键id
 * @returns 
 */
export function deviceVersion(id) {
  return request({
    method: "get",
    url: `/command/v2/device/version/${id}`,
  })
}


/**
 * 查询设备版本详情信息新版
 * @param {string} stationId 电站id
 * @param {string} uuid 设备UUID
 * @param {string} recordTime 
 * @param {string} createTime 
 * @returns 
 */
export function deviceVersionDetail(stationId, uuid, recordTime, createTime) {
  return request({
    method: "get",
    url: `/command/v2/device/version/getDetail`,
    params: {
      stationId,
      uuid,
      recordTime,
      createTime
    }
  })
}


